// extracted by mini-css-extract-plugin
module.exports = {"methodsListsContainer":"MethodsListsBlock_methodsListsContainer__3IlwH","methodsListContainer":"MethodsListsBlock_methodsListContainer__t46ig"};